<template>

    <ul class="tabs">
        <li v-for="(tab,index) in items" :index="index" class="index-title">
            <i>0{{index+1}}</i><a href="javascript:void(0)" class="tab-link" @click="tabsSwitch(index)"
               v-bind:class="{active:tab.isActive}">{{tab.title}}</a>
        </li>
    </ul>


</template>

<script>
    export default {
        name: "change-tab",
        props: ['items'],
        methods: {
            tabsSwitch: function (tabIndex) {
                var tabCardCollection = document.querySelectorAll(".tab-card"),
                    len = tabCardCollection.length;

                for (var i = 0; i < len; i++) {
                    tabCardCollection[i].style.display = "none";
                    this.items[i].isActive = false;
                }
                this.items[tabIndex].isActive = true;
                tabCardCollection[tabIndex].style.display = "block";
            }
        }
    }
</script>

<style lang="less">
    /*.img-pro {*/
    /*width: 100%;*/
    /*.tab-card {*/
    /*display: none;*/
    /*}*/

    /*.tab-card:nth-child(1) {*/
    /*display: block;*/
    /*}*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/common/changeTab.vue